import styled from 'styled-components'
import { Input, Button } from '@sainsburys-tech/bolt'

const SearchBar = styled.form`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
`

const SearchInput = styled(Input)`
  &:hover,
  &:focus,
  &:active {
    border: 1px solid ${props => props.theme.color.monochrome.base};
  }
`

const ButtonContainer = styled.div`
  position: relative;
  margin-left: -2px;
`

const SearchButton = styled(Button)`
  border-width: 1px;
  border-radius: 0 3px 3px 0;
  margin-top: 1px;
`

const SearchIconContainer = styled.div`
  left: 20px;

  svg {
    margin-right: 0;
  }
`

export { SearchBar, SearchInput, SearchButton, ButtonContainer, SearchIconContainer }
